import React from "react";
import { AbsoluteFill, interpolate, useCurrentFrame, useVideoConfig } from "remotion";
import { useEnvelope, ShareIcon, BTN_SHADOW, TEXT_SHADOW } from "./CTAKit";

// CTA #3 — SHARE. Arrow icon that "sends" (slides + fades a ghost arrow). Lower-right.
export const CTAShare: React.FC<{ right?: number; bottom?: number }> = ({ right = 90, bottom = 110 }) => {
  const { o, s, y } = useEnvelope();
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  // a ghost arrow flies off every ~1.4s
  const cycle = (frame - fps * 0.5) % (fps * 1.4);
  const ghostO = interpolate(cycle, [0, 4, fps * 0.7], [0, 0.9, 0], { extrapolateLeft: "clamp", extrapolateRight: "clamp" }) * (frame > fps * 0.5 ? 1 : 0);
  const ghostX = interpolate(cycle, [0, fps * 0.7], [0, 46], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });
  const ghostY = interpolate(cycle, [0, fps * 0.7], [0, -22], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });

  return (
    <AbsoluteFill style={{ justifyContent: "flex-end", alignItems: "flex-end", paddingRight: right, paddingBottom: bottom }}>
      <div style={{ position: "relative", opacity: o, transform: `translateY(${y}px) scale(${s})`, display: "flex", alignItems: "center", gap: 14 }}>
        <div style={{ color: "#fff", fontFamily: "Inter, Arial, sans-serif", fontWeight: 900, fontSize: 30, letterSpacing: 1.5, textShadow: TEXT_SHADOW }}>
          SHARE WITH A FRIEND
        </div>
        <div style={{ position: "relative", width: 70, height: 70, borderRadius: 999, background: "#16a34a", display: "flex", alignItems: "center", justifyContent: "center", boxShadow: BTN_SHADOW }}>
          <ShareIcon size={36} />
          <div style={{ position: "absolute", opacity: ghostO, transform: `translate(${ghostX}px, ${ghostY}px)` }}>
            <ShareIcon size={36} color="rgba(255,255,255,0.9)" />
          </div>
        </div>
      </div>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
